import {
  getCurrentCropYear,
  getCropYears,
  getAllCustomerFarmFields,
  saveCarbonScoringAnswers,
  getCarbonScoringAnswers,
} from '../../../apis/premier-plus-api';
import { handleApiError } from '../../../shared/actions';

export const initCarbonScoringInterface = () => (async (dispatch, getState) => {
  dispatch({
    type: 'INIT_CARBON_SCORING_INTERFACE',
  });
  await dispatch(fetchCropYears());
  await dispatch(fetchCurrentCropYear());
  dispatch(fetchFarmFields());
});

export const fetchCurrentCropYear = () => (async (dispatch, getState) => {
  var response = null;
  try {
    response = await getCurrentCropYear();
  }
  catch (error) {
    dispatch(handleApiError(error));
    return;
  }
  dispatch({
    type: 'FETCHED_CARBON_SCORING_CURRENT_CROP_YEAR',
    currentCropYear: response.body,
  });
});

export const fetchCropYears = () => (async (dispatch, getState) => {
  var response = null;
  try {
    response = await getCropYears();
  }
  catch (error) {
    dispatch(handleApiError(error));
    return;
  }
  dispatch({
    type: 'FETCHED_CARBON_SCORING_CROP_YEARS',
    cropYears: response.body,
  });
});

export const fetchFarmFields = () => (async (dispatch, getState) => {
  dispatch({
    type: 'FETCHED_CARBON_SCORING_FARM_FIELDS_STARTED',
  });
  const growerId = getState().auth.authorization.growerId;
  const cropYear = getState().carbonScoring.selectedCropYear;
  var response = null;
  try {
    response = await getAllCustomerFarmFields(growerId, cropYear);
  }
  catch (error) {
    dispatch({
      type: 'FETCHED_CARBON_SCORING_FARM_FIELDS_FAILED',
    });
    dispatch(handleApiError(error));
    return;
  }
  dispatch({
    type: 'FETCHED_CARBON_SCORING_FARM_FIELDS',
    farmFields: response.body,
  });
});

export const userSelectedCropYear = (selectedCropYear) => (async (dispatch, getState) => {
  dispatch({
    type: 'USER_SELECTED_CARBON_SCORING_CROP_YEAR',
    selectedCropYear: selectedCropYear,
  });
});

export const userSelectedFarmField = (selectedFarmField) => (async (dispatch, getState) => {
  dispatch({
    type: 'USER_SELECTED_CARBON_SCORING_FARM_FIELD',
    selectedFarmField: selectedFarmField,
  });
});

export const submitCarbonScoring = (formData, formQuestions) => (async (dispatch, getState) => {
  dispatch({
    type: 'SUBMITTING_CARBON_SCORING_ANSWERS_STARTED',
  });
  const structuredAnswers = formQuestions.map(question => {
    const answer = formData[question.id] || null;
    let answerFormatted = null;
    if (question.type === 'radio' && answer) {
      const selectedOption = question.options.find(opt => opt.value === answer);
      if (selectedOption) {
        answerFormatted = selectedOption.label;
      }
    }
    else {
      answerFormatted = answer;
    }
    return {
      id: question.id,
      label: question.label,
      hint: question.hint || null,
      type: question.type,
      required: question.required || false,
      answer,
      answerFormatted,
      sortOrder: question.sortOrder,
    };
  });
  const payload = {
    growerID: getState().auth.authorization.growerId,
    cropYear: getState().carbonScoring.selectedCropYear,
    fieldGUID: getState().carbonScoring.selectedFarmField.fieldGUID,
    farmName: getState().carbonScoring.selectedFarmField.farmName,
    questionsAndAnswers: structuredAnswers,
    submittedAt: new Date().toISOString(),
  };
  try {
    const response = await saveCarbonScoringAnswers(payload);
    dispatch({
      type: 'SUBMITTED_CARBON_SCORING_SUCCESS',
      response: response.body,
    });
    dispatch(fetchFarmFields());
  }
  catch (error) {
    dispatch({
      type: 'SUBMITTING_CARBON_SCORING_ANSWERS_FAILED',
    });
    dispatch(handleApiError(error));
  }
});

export const fetchCarbonScoringAnswers = () => (async (dispatch, getState) => {
  const growerId = getState().auth.authorization.growerId;
  const cropYear = getState().carbonScoring.selectedCropYear;
  const fieldGUID = getState().carbonScoring.selectedFarmField.fieldGUID;
  try {
    const response = await getCarbonScoringAnswers(growerId, cropYear, fieldGUID);
    const answers = {};
    if (response.body && response.body.questionsAndAnswers) {
      response.body.questionsAndAnswers.forEach(qa => {
        if (qa.answer !== null && qa.answer !== undefined) {
          answers[qa.id] = qa.answer;
        }
      });
    }
    dispatch({
      type: 'FETCHED_CARBON_SCORING_ANSWERS',
      answers,
    });
  } 
  catch (error) {
    dispatch({
      type: 'FETCHED_CARBON_SCORING_ANSWERS',
      answers: {},
    });
    dispatch(handleApiError(error));
  }
});
